module.exports = __webpack_public_path__ + "img/loading2.616f265d.png";